module.exports = {"npc_death":"Hodor","player_death":"Hodor","player_spell":"Hodor"};